import Vue from 'vue'
import { reportError } from '@/api/common'
import store from './store'
import { parseTime } from '@/utils/index'
import { hex_md5 } from '@/utils/md5'
export default {
  vueError: () => {
    if (process.env.NODE_ENV === 'production') {
      Vue.config.errorHandler = function(err, vm, info) {
        const date = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
        if (process.env.NODE_ENV === 'production') {
          console.error(err)
          const {
            message,
            name
          } = err
          let errMsg = {}
          if (vm) {
            const componentName = formatComponentName(vm)
            const propsData = vm.$options && vm.$options.propsData
            errMsg = {
              userName: store.getters.name,
              date: date,
              errorType: 'vueError',
              componentName,
              propsData,
              errInfo: info,
              errMsg: `${name}:${message}`,
              code: hex_md5(`${name}:${message}`)
            }
          } else {
            errMsg = {
              userName: store.getters.name,
              date: date,
              errMsg: `${name}:${message}`,
              errInfo: info,
              errorType: 'vueErrorNoVm',
              code: hex_md5(`${name}:${message}`)
            }
          }
          reportError({
            navigator: { app: navigator.appVersion },
            error_message: errMsg,
            router_name: window.location.href
          })
        }
      }
    }
  }
}

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root'
  const name = vm._isVue
    ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
    : vm.name
  return (
    (name ? 'component <' + name + '>' : 'anonymous component') +
      (vm._isVue && vm.$options && vm.$options.__file
        ? ' at ' + (vm.$options && vm.$options.__file)
        : '')
  )
}
